import { render, staticRenderFns } from "./Credito.vue?vue&type=template&id=022e0b58&"
import script from "./Credito.vue?vue&type=script&lang=js&"
export * from "./Credito.vue?vue&type=script&lang=js&"
import style0 from "./Credito.vue?vue&type=style&index=0&id=022e0b58&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports